import React from 'react';
import { motion } from 'framer-motion';

const ImageSeparator = ({ image, title, subtitle, className = "" }) => {
  return (
    <section className={`relative section-padding overflow-hidden ${className}`}>
      <div className="absolute inset-0 z-0">
        <img 
          src={image} 
          alt={title || "AMHAS Healthcare"} 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center py-12"
        >
          {title && (
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default ImageSeparator;

